import React from "react";

export default function Mensaje131098() {
  return (
    <>
      <p>
        <h6>13 de octubre de 1998</h6>
        <br />
        <p>
          ¡Alabado sea El Altísimo!. <br />
          Sed benditos hijos míos, sed humildes servidores del Señor en vuestras
          vidas. <br />
          Sed pacientes en las pruebas y Misericordiosos de Corazón. Convertíos
          en Testigos del Amor del Corazón Amantísimo de <br />
          Jesús. ¡Oh Misterios de Dios! que acercáis la Gracia a los pequeños y{" "}
          <br />
          humildes de corazón. <br />
          ¡Gloria a Dios! <br />
          Amén. Aleluya. Amén. Aleluya. <br />
          Luego vi una hermosa paloma blanca llena de Luz sobre mi cabeza. Sentí
          estas palabras. <br />
          Escribe: <br />
          <i>
            ¡Me gozo en Ti Señor! <br />
            Que mi lengua te alabe y te bendiga. <br />
            Que mis ojos te busquen y mis manos te sirvan. Que en Ti repose mi
            alma. <br />
            Que el gozo y la alegría de mi corazón sean perfectos en Tu Santa
            Presencia. <br />
            Amén
          </i>
        </p>
      </p>
    </>
  );
}
